export const DATA_REQUEST = 'STALLION_DATA_REQUEST';
export const DATA_SUCCESS = 'STALLION_DATA_SUCCESS';
export const DATA_FAILURE = 'STALLION_DATA_FAILURE';
export const RAW_DATA_SUCCESS = 'STALLION_RAW_DATA_SUCCESS';
export const RAW_DATA_REQUEST = 'STALLION_RAW_DATA_REQUEST';
export const MOST_FEATURED_REQUEST = 'MOST_FEATURED_REQUEST';
export const MOST_FEATURED_SUCCESS = 'MOST_FEATURED_SUCCESS';
export const MOST_FEATURED_FAILURE = 'MOST_FEATURED_FAILURE';



// WEBPACK FOOTER //
// ./src/client/actions/stallion/index.js